module.exports = __webpack_public_path__ + "static/img/building.3b1b5176.png";